import { CURRENCY_DETAILS_LIST } from "./CurrencyDetails";
export function getCurrencySymbol(currency) {
    const symbol = CURRENCY_DETAILS_LIST[currency]?.nativeSymbol;
    if (symbol)
        return symbol;
    else
        return currency;
}
//# sourceMappingURL=index.js.map